import {SET_BREADCRUMBS, SET_CONTEXT, SET_TOOLBARS} from "../Actions/Types/contextActionTypes";

const initialState = {
    context: {},
    breadcrumbs: [],
    toolbars: [],
    url: null,
};

export const contextReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CONTEXT:
            return {
                ...state,
                context: action.context,
            };
        case SET_BREADCRUMBS:
            return {
                ...state,
                breadcrumbs: action.breadcrumbs,
            };
        case SET_TOOLBARS:
            return {
                ...state,
                toolbars: action.toolbars,
            };
        default:
            return state;
    }
};


